import { useState } from "react";
import axios from "axios";
import * as Icon from 'react-bootstrap-icons';
import configData from "../config.json";

export default function FileUploader() {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState(null);
  const [uploadProgress, setUploadProgress] = useState(0);
  
  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    setFile(selectedFile);
  };

  const handleUpload = async () => {
    if (!file) return;
    
    const formData = new FormData();
    formData.append("file", file);
    
    try {
      const response = await axios.post(configData.SERVER_URL+"/fileupload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percent);
        },
      });
      
      alert("File uploaded successfully!");
      console.log(response.data);
    } catch (error) {
      console.error("Upload error:", error);
    }
  };

  return (
    <div className="max-w-md mx-auto p-4 border rounded-lg shadow-lg text-center">
      <input type="file" onChange={handleFileChange} className="mb-4" />
      {preview && <img src={preview} alt="Preview" className="w-full h-32 object-cover rounded-lg mb-4" />}
      {uploadProgress > 0 && <Icon.Pencil value={uploadProgress} className="mb-4" />}
      <button onClick={handleUpload} disabled={!file}>Upload</button>
    </div>
  );
}